export const finalAssessmentSelector = (state) => state.finalAssessment.test;
export const finalAssessmentResultSelector = (state) =>
  state.finalAssessment.result;
